import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga';

import { config } from '@formue-app/core';

export const usePageTracking = () => {
  const location = useLocation();
  const [initialized, setInitialized] = useState(false);

  const { enabled, code } = config.ga;

  useEffect(() => {
    if (enabled) {
      ReactGA.initialize(code);
      setInitialized(true);
    }
  }, [enabled, code]);

  useEffect(() => {
    if (initialized) {
      ReactGA.pageview(location.pathname + location.search);
    }
  }, [initialized, location]);
};
